<template>
  <div v-if="getLabels?.length > 0 && screenWidth > 992" class="def-labels">
    <div
      v-for="item in getLabels"
      :key="item.name"
      class="def-labels__item"
      :style="`background-color: ${item.color}; color: ${item?.fontColor}`"
    >
      <DefInformText v-if="item.text">
        <template #content>
          <DefContent v-html="item.text" />
        </template>
        <span>
          {{ item.name }}
        </span>
      </DefInformText>
      <span v-else>
        {{ item.name }}
      </span>
    </div>
  </div>
  <div v-else-if="getLabels?.length" class="def-labels">
    <div
      v-for="item in getLabels"
      :key="item.name"
      class="def-labels__item"
      :style="`background-color: ${item.color}; color: ${item?.fontColor}`"
      @click="handlerOpenModal(item)"
    >
      {{ item.name }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import DefInformText from '@components/Def/DefInformText/DefInformText.vue';
import DefContent from '@components/Def/DefContent/DefContent.vue';
import useScreenWidth from '@use/useScreenWidth';
import DefLabelsTagsModal from '@components/Def/DefLabels/DefLabelsTagsModal.vue';
import useModalAside from '@use/useModalAside/useModalAside';

const props = defineProps(['result']);

const screenWidth = useScreenWidth();
const modalAside = useModalAside();

const getLabels = computed(() => props.result?.filter((item) => !item.picture));

const handlerOpenModal = (label) => {
  if (!label.text) return;

  modalAside.show(
    DefLabelsTagsModal,
    {
      result: label,
    },
    {}
  );
};
</script>

<style lang="scss" scoped>
.def-labels {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  &__item {
    display: block;
    padding: 4px 8px;
    font-size: 12px;
    font-weight: 600;
    line-height: 125%;
    text-transform: uppercase;
    white-space: nowrap;
  }
}
</style>
